import PropTypes from 'prop-types';
import {Views} from 'react-big-calendar';
import moment from 'moment';
import React from 'react';
import Button from '../bootstrap/Button';
import Dropdown, {DropdownItem, DropdownMenu, DropdownToggle} from '../bootstrap/Dropdown';
import {useTranslation} from 'react-i18next';
import Icon from 'components/icon/Icon';
import Txt from 'components/common/ui/Txt';

export const getUnitType = (viewMode) => {
	let unitType = null;
	switch (viewMode) {
		case Views.WEEK:
		case Views.WORK_WEEK:
			unitType = Views.WEEK;
			break;
		case Views.MONTH:
		case Views.AGENDA:
			unitType = Views.MONTH;
			break;
		default:
			unitType = Views.DAY;
	}
	return unitType;
};

export const getLabel = (date, viewMode) => {
	if (viewMode === Views.MONTH) return moment(date).format('MMMM YYYY');

	if (viewMode === Views.WEEK)
		return `${moment(date).startOf('week').format('MMM D')} - ${moment(date).endOf('week').format('MMM D')}`;

	if (viewMode === Views.WORK_WEEK)
		return `${
				moment(date)
				.startOf('week')
				.add(1, 'day')
				.format('MMM D')
			} - ${
				moment(date)
				.endOf('week')
				.add(-1, 'day')
				.format('MMM D')
			}`;

	if (viewMode === Views.AGENDA)
		return `${moment(date).format('YYYY-MM-DD')} - ${moment(date).add(1, 'month').format('YYYY-MM-DD')}`;

	return moment(date).format('dddd, MMM D');
};

export const getTodayButtonLabel = (viewMode) => {
	if (viewMode === Views.MONTH || viewMode === Views.AGENDA) return 'This month';
	if (viewMode === Views.WEEK || viewMode === Views.WORK_WEEK) return 'This week';
	return 'Today';
};

export const getViews = () => {
	return Object.keys(Views).map((k) => Views[k]);
};

export const CalendarTodayButton = ({ setDate, date, unitType, viewMode, calendarDateLabel, mobileDesign }) => {

	const onClickPrev = () => {
		setDate(moment(date).add(-1, unitType)._d);
	}
	const onClickNext = () => {
		setDate(moment(date).add(1, unitType)._d);
	}
	const onClickToday = () => {
		setDate(moment()._d);
	}

	return (
		<div>
			{!mobileDesign && (
				<div className='calendar_btn_box'>
					<Button
						className='btn_prev'
						onClick={onClickPrev}
						aria-label='Prev'
					/>
					<Button
						className='btn_current'
						onClick={onClickToday}
					>
						<Txt variant='num_lg'>{calendarDateLabel}</Txt>
					</Button>
					<Button
						className='btn_next'
						onClick={onClickNext}
						aria-label='Next'
					/>
				</div>
			)}
			{mobileDesign && (
				<div class="d-flex align-items-center gap-2 justify-content-start month-wrapper">
					<button type="button" class="btn btn-custom-icon" aria-label="Prev" onClick={onClickPrev}>
						<svg xmlns="http://www.w3.org/2000/svg" height="2.2em" viewBox="0 0 24 24" width="2.2em" fill="currentColor"><path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z" /></svg>
					</button>

					<div class="month-display d-flex align-items-center gap-2 justify-content-end" onClick={onClickToday} style={{ cursor: 'pointer' }}>
						<span class="icon-calendar-wrapper">
							<Icon icon={'SvgCalendarWorkCalendar'}
								color={null}
								style={{  display: 'flex', flexShrink: 0, fill: 'none' }}
								height={'1.5em'}
								width={'1.5em'}
								fill={'none'}
							/>
						</span>
						<span class="month-text">{calendarDateLabel}</span>
					</div>

					<button type="button" class="btn btn-custom-icon" aria-label="Next" onClick={onClickNext}>
						<svg xmlns="http://www.w3.org/2000/svg" height="2.2em" viewBox="0 0 24 24" width="2.2em" fill="currentColor"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z" /></svg>
					</button>
				</div>)}
		</div>
	);
};
CalendarTodayButton.propTypes = {
	setDate: PropTypes.func.isRequired,
	// eslint-disable-next-line react/forbid-prop-types
	date: PropTypes.object.isRequired,
	unitType: PropTypes.string.isRequired,
	viewMode: PropTypes.string.isRequired,
};

export const CalendarViewModeButtons = ({ viewMode, setViewMode }) => {
	const { t } = useTranslation(); //번역관련

	return (
		<Dropdown>
			<DropdownToggle>
				<Button
					color='primary'
					isLight
					icon={
						(viewMode === Views.MONTH && 'calendar_view_month') ||
						(viewMode === Views.WEEK && 'calendar_view_week') ||
						(viewMode === Views.WORK_WEEK && 'view_week') ||
						(viewMode === Views.DAY && 'calendar_view_day') ||
						'view_agenda'
					}>
					{t((viewMode === Views.MONTH && 'Month') ||
						(viewMode === Views.WEEK && 'Week') ||
						(viewMode === Views.WORK_WEEK && 'Work Week') ||
						(viewMode === Views.DAY && 'Day') ||
						'Agenda')}
				</Button>
			</DropdownToggle>
			<DropdownMenu isAlignmentEnd>
				<DropdownItem>
					<Button
						color='link'
						icon='calendar_view_month'
						isActive={viewMode === Views.MONTH}
						onClick={() => setViewMode(Views.MONTH)}>
						{t('Month')}
					</Button>
				</DropdownItem>
				<DropdownItem>
					<Button
						color='link'
						icon='calendar_view_week'
						isActive={viewMode === Views.WEEK}
						onClick={() => setViewMode(Views.WEEK)}>
						{t('Week')}
					</Button>
				</DropdownItem>
				{/* <DropdownItem>
					<Button
						color='link'
						icon='view_week'
						isActive={viewMode === Views.WORK_WEEK}
						onClick={() => setViewMode(Views.WORK_WEEK)}>
						Work Week
					</Button>
				</DropdownItem> */}
				<DropdownItem>
					<Button
						color='link'
						icon='calendar_view_day'
						isActive={viewMode === Views.DAY}
						onClick={() => setViewMode(Views.DAY)}>
						{t('Day')}
					</Button>
				</DropdownItem>
				{/* <DropdownItem>
					<Button
						color='link'
						icon='view_agenda'
						isActive={viewMode === Views.AGENDA}
						onClick={() => setViewMode(Views.AGENDA)}>
						Agenda
					</Button>
				</DropdownItem> */}
			</DropdownMenu>
		</Dropdown>
	);
};
CalendarViewModeButtons.propTypes = {
	viewMode: PropTypes.string.isRequired,
	setViewMode: PropTypes.func.isRequired,
};
